//
//
//
//
//
//
//
//
//
//
//

import dayjs from 'dayjs';
export default {
  async asyncData({ $content }) {
    const md = await $content('terms-of-service').fetch();
    return {
      md
    };
  },
  methods: {
    lastUpdated(md) {
      return dayjs(md.updated_at, 'MM-DD-YYYY').format('LL');
    }
  },
  head: {
    title: 'Terms of Service | BOMIST',
    meta: [{ name: 'robots', content: 'noindex,nofollow,noarchive' }]
  }
};
